import { useHistory } from "react-router-dom";

const withAuthentication = (WrappedComponent: any) => {
  return (props: any) => {
    const router = useHistory();
    if (typeof window !== "undefined") {
      if (localStorage.token) {
        router.replace("/home");
        return null;
      }

      return <WrappedComponent {...props} />;
    }

    return null;
  };
};

export default withAuthentication;
